/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { MenuItem, TextField } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  dispatchErrorMsgPerformDis,
  dispatchFullScrrenRequestMfgGrid,
  dispatchGetInvoiceHeader,
  dispatchManufacturerValue,
  dispatchPerformDisputeDetailObj,
  dispatchPerformDisputeResolutionObj,
  dispatchSaveCancelClaimsDetail,
  dispatchSelectedRowInMfgGrid,
  dispatchSetDisplayCurrentDisputesPage,
  getDisplayCurrentDisputes,
  getInvoiceHeader,
  getManufacturerDataForGrid,
  getPlanTypeValues,
  getQuarterValue,
  getRebateProgrameList,
} from '../store/actions';
import {
  FAILED_MESSAGE_GENERIC,
  MNFC_NDC_ERROR_MSG,
  QUARTER_VALUE_REQUIRED,
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  VALIDATE_QUARTER_VALUE,
  MANUFACTURER_ID_REQUIRED
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getQtrValWithoutQ,
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { mfgForRcddColoumData } from './gridComponent/TableHead';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { navigateToRequest } from './ConstantData';

const RequestCurrentDisputeDisplay = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.performDisputeResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.PerformDisputeResolutionReducer?.planType
  );
  const getManufacturerDataList = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.mfgDataForGrid
  );
  const getQuarterDataValue = useSelector(
    (state) => state?.sharedState?.PerformDisputeResolutionReducer?.quarter
  );
  const getErrorMsg = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.errorMsgPerDisRes
  );
  const rowSelectedInRedux = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.selectedRowData
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const requestScrMfgGridFullScrren = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.requestScrrenMfgFullScreen
  );
  // local variable

  const [state, setState] = useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          quarterValue: null,
        }
  );
  const [radioList, setRadioList] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [mfgList, setMfgList] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [getMfgId, setGetMfgId] = useState();
  const [gridParams, setGridParams] = useState('');
  const [rebateProList, setRebateProList] = React.useState([]);
  const [searchCompleted, setSearchCompleted] = React.useState(false);
  // dispatch function
  const setPerformDisputeScrData = (value) =>
    dispatch(dispatchPerformDisputeResolutionObj(value));
  // Plan type useEffect
  React.useEffect(() => {
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);

  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    let rebateCd = dispatch(getRebateProgrameList(state.planTypeCd));
    rebateCd.then((res) => setRebateProList(res));
  }, [state.planTypeCd]);
  // set Rebate Program List
  React.useEffect(() => {
    let list = [];
    if (
      rebateProList?.status === STATUS_MSG &&
      rebateProList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(rebateProList.data)) {
        list = _.map(rebateProList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [rebateProList]);
  //  get quarter value useEffect
  React.useEffect(() => {
    if (_.isEmpty(getQuarterDataValue)) {
      dispatch(getQuarterValue());
    }
    handleScrollToEvent();
  }, []);
  // set quarter value
  React.useEffect(() => {
    let quarter = '';
    if (
      getQuarterDataValue?.status === STATUS_MSG &&
      getQuarterDataValue?.message === SUCCESS_MSG
    ) {
      const receivedQuarter = getQuarterDataValue?.data;
      if (receivedQuarter) {
        quarter = receivedQuarter;
      }
    }
    if (_.isEmpty(requestCurrentDisData?.state?.quarterValue)) {
      setState({ ...state, quarterValue: quarter });
      setPerformDisputeScrData({
        state: { ...state, quarterValue: quarter },
      });
    }
  }, [getQuarterDataValue]);
  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformDisputeScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformDisputeScrData({
        state: { ...state, [name]: value },
      });
    }
    if (name === 'quarterValue') {
      setState({ ...state, [name]: value });
      setPerformDisputeScrData({
        state: { ...state, [name]: value },
      });
    }
  };
  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'quarter') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          setPerformDisputeScrData({
            state: {
              ...state,
              quarterValue: autoFormateDate(value?.toUpperCase()),
            },
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPerformDis(unique));
  };
  // Rebate programe error on plan type change
  React.useEffect(() => {
    handleOnblurEvent('rebateProgramCd', '1');
  }, [state.planTypeCd]);
  // to check search completed via state
  React.useEffect(() => {
    if (searchCompleted) {
      gridParams.api.forEachNode(
        (node) => node.rowIndex === 0 && node.setSelected(true)
      );
      gridParams.api.setFilterModel(null);
      setGridParams(gridParams);
      const selectedRowNodes = gridParams.api.getSelectedNodes();
      onSingleClickOnSPecificRow(selectedRowNodes[0]?.data);
      setSearchCompleted(false);
    }
  }, [searchCompleted]);
  //  on click functionality on search button
  const onClickOnSearch = async () => {
    let localErr = [];
    if (state?.rebateProgramCd !== '-1') {
      const indexOf = !_.isEmpty(localErr)
        ? _.findIndex(localErr, {
            field: 'rebateProgramCd',
            errorType: 'required',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        localErr.splice(indexOf, 1);
      }
    } else {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'required',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    if (
      state?.quarterValue &&
      !_.isEmpty(state?.quarterValue) &&
      !_.isNaN(state?.quarterValue)
    ) {
      const indexOf = !_.isEmpty(localErr)
        ? _.findIndex(localErr, {
            field: 'quarter',
            errorType: 'required',
          })
        : null;

      if (!_.isNull(indexOf) && indexOf >= 0) {
        localErr.splice(indexOf, 1);
      }
      if (
        quarterTest1.test(state?.quarterValue) ||
        quarterTest2.test(state?.quarterValue)
      ) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'invalidFormat',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        localErr = localErr.filter((item) => item.field !== 'quarter');
        setState({ ...state, quarterValue: state?.quarterValue });
        setPerformDisputeScrData({
          state: { ...state, quarterValue: state?.quarterValue },
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'invalidFormat',
          message: VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state?.rebateProgramCd !== '-1' && state?.quarterValue !== '') {
      const quaValue = state?.quarterValue;
      const obj = {
        planTypeCd: state?.planTypeCd,
        rebateProgramCd: state?.rebateProgramCd,
        quarter: quaValue,
      };
      const resp = await dispatch(getManufacturerDataForGrid(obj));
      //setTimeout(() => {
      if (resp?.payload?.manufacturers?.length > 0) {
        setSearchCompleted(true);
      }
      //}, 500);
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPerformDis(unique));
  };
  // manufacturer table data useEffect
  React.useEffect(() => {
    let list = [];
    let localErr = getErrorMsg ? getErrorMsg : [];
    if (
      getManufacturerDataList?.status === STATUS_MSG &&
      getManufacturerDataList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getManufacturerDataList.manufacturers)) {
        list = _.map(getManufacturerDataList.manufacturers, (val) => ({
          ...val,
          id: val.mfgId,
          mfgName: val.mfgName,
          mfgTypeCd: val.mfgTypeCd,
        }));
        localErr = localErr.filter((item) => item.field !== 'cmsDetailsGrid');
      } else {
        localErr = localErr.filter((item) => item.field !== 'cmsDetailsGrid');
        localErr.push({
          field: 'cmsDetailsGrid',
          errorType: 'noDataforPerSelection',
          message: MNFC_NDC_ERROR_MSG,
        });
        dispatch(dispatchManufacturerValue([]));
      }
    }
    setMfgList(list);
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPerformDis(unique));
  }, [getManufacturerDataList]);
  // on double click on specific row
  const doubleClickOnSpecificRow = async (data) => {
    const mfgIdForPay = data?.mfgId;
    const mfgNameForPay = data?.mfgName;
    if (mfgIdForPay !== '') {
      const payForDetail = {
        rebateProgram: state?.rebateProgramCd,
        quarter: state?.quarterValue,
        mfgId: mfgIdForPay,
      };
      //handleGetInvoiceDetails(payForDetail);
      const processBtnResult = await dispatch(
        getDisplayCurrentDisputes(payForDetail)
      );
      const response = processBtnResult && processBtnResult.payload;
      if (
        response &&
        response.displayDispHeaderAndGridRespVOList &&
        response.displayDispHeaderAndGridRespVOList.length > 0
      ) {
        tabHighLigther(navigateToRequest, false);
        let Obj = {};
        Obj.mfgID = mfgIdForPay;
        Obj.mfgName = mfgNameForPay;
        Obj.rebatePrograme = state?.rebateProgramCd;
        dispatch(dispatchPerformDisputeDetailObj(Obj));
        dispatch(
          dispatchSetDisplayCurrentDisputesPage({
            pageCount: 1,
            disputesList: response.displayDispHeaderAndGridRespVOList,
          })
        );
        redirectURLLink(
          '/displayCurrentDisputes',
          'Display Current Disputes',
          history,
          dispatch
        );
      }
    }
  };
  const handleGetInvoiceDetails = (data) => {
    dispatch(dispatchGetInvoiceHeader({}));
    dispatch(
      getInvoiceHeader({
        isMFG: data?.mfgId,
        isPrevQTR: data?.quarter,
        isProgramCode: data?.rebateProgram,
      })
    );
  };
  const onSingleClickOnSPecificRow = (data) => {
    dispatch(dispatchSelectedRowInMfgGrid({ mfgId: data?.mfgId }));
    setGetMfgId(data);
  };

  const clickHandlerOnProcess = async () => {
    let localErr = [];
    const mfgIdForPay = getMfgId?.mfgId;
    const mfgNameForPay = getMfgId?.mfgName;
      if(mfgIdForPay==''||mfgIdForPay==undefined){
        localErr = localErr.filter((item) => item.field !== 'mfgIdForPay');
        localErr.push({
          field: 'mfgIdForPay',
          errorType: 'manufactureRequired',
          message: MANUFACTURER_ID_REQUIRED,
        });
      }
      if(localErr&&localErr.length==0){
    if (mfgIdForPay !== '') {
      const payForDetail = {
        rebateProgram: state?.rebateProgramCd,
        quarter: state?.quarterValue,
        mfgId: mfgIdForPay,
      };
      const processBtnResult = await dispatch(
        getDisplayCurrentDisputes(payForDetail)
      );
      const response = processBtnResult && processBtnResult.payload;
      if (
        response &&
        response.displayDispHeaderAndGridRespVOList &&
        response.displayDispHeaderAndGridRespVOList.length > 0
      ) {
        tabHighLigther(navigateToRequest, false);
        let Obj = {};
        Obj.mfgID = mfgIdForPay;
        Obj.mfgName = mfgNameForPay;
        Obj.rebatePrograme = state?.rebateProgramCd;
        dispatch(dispatchPerformDisputeDetailObj(Obj));
        dispatch(
          dispatchSetDisplayCurrentDisputesPage({
            pageCount: 1,
            disputesList: response.displayDispHeaderAndGridRespVOList,
          })
        );
        dispatch(dispatchSaveCancelClaimsDetail(true));
        redirectURLLink(
          '/displayCurrentDisputes',
          'Display Current Disputes',
          history,
          dispatch
        );
        localErr = localErr.filter(
          (item) => item.field !== 'apiGiving500Error'
        );
      } else {
        handleScrollToEvent();
        localErr = localErr.filter(
          (item) => item.field !== 'apiGiving500Error'
        );
        localErr.push({
          field: 'cmsDetailsGrid',
          errorType: 'apiGiving500Error',
          message: FAILED_MESSAGE_GENERIC,
        });
      }
    }
  }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPerformDis(unique));
  };
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(dispatchFullScrrenRequestMfgGrid(fullScreenView));
  };

  // on gride ready functionality
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridParams(params);
  };
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  return (
    <>
      <div
        className=" tabs-container tBillPanel custom-check"
        data-testid="request-current-dispute-display"
      >
        <Spinner load={spinnerLoader} />
        {!requestScrMfgGridFullScrren && (
          <CustomSeparator
            parent1="Tasks"
            parent2="Request Current Dispute Display"
          />
        )}
        {getErrorMsg?.length > 0 ? (
          <DisplayErrorMessages
            errorMessages={
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            }
          />
        ) : null}
        {!requestScrMfgGridFullScrren && (
          <div className="row">
            <div className="col-12 col-sm-12 col-md-9">
              <div className="row">
                <div className="col-12 col-sm-7 frr-two-col-radio">
                  <RadioGroupComponent
                    data-testid="radio-button-for-rcdd"
                    id="radio-button-for-rcdd_id"
                    labelName="Plan Type"
                    required
                    reqColor
                    optionList={radioList || []}
                    defaultValue={state && state.planTypeCd}
                    filterAction={(e) => {
                      handleOnChangeEvent(e, 'planTypeCd');
                    }}
                    className="log-batch-filter-radio frr-checkInvoiceRadio"
                  />
                </div>
                <div className="col-12 col-sm-5 mt-2 mt-sm-0">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Rebate Program <span className="mandatory"> *</span>
                    </legend>
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <TextField
                          name="rebateProgram"
                          id="rebate_program"
                          label="Rebate Program"
                          data-testid="text-field-for-rebate-program"
                          fullWidth
                          select
                          required
                          inputProps={{ maxLength: 11, id: 'rebate_program' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? 'mandate-fields'
                                    : null
                                )
                              : null
                          }
                          onBlur={(e) =>
                            handleOnblurEvent('rebateProgramCd', e.target.value)
                          }
                          onChange={(e) =>
                            handleOnChangeEvent(
                              e.target.value,
                              'rebateProgramCd'
                            )
                          }
                          value={
                            state && state.rebateProgramCd
                              ? state.rebateProgramCd
                              : ''
                          }
                          error={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                          helperText={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                  l.field === 'rebateProgramCd'
                                    ? l.message
                                    : null
                                )
                              : null
                          }
                        >
                          <MenuItem
                            key=""
                            value="-1"
                            className="frr-dropdown-blank-item"
                          />
                          {rebateProgramList?.length > 0
                            ? rebateProgramList.map((item) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </TextField>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-3">
              <div className="mui-custom-form mx-0">
                <TextField
                  data-testid="quarter_field_rcdd"
                  id="quarter_field_rcdd_id"
                  required
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'quarter' ? 'mandate-fields' : null
                        )
                      : null
                  }
                  label="Quarter"
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state && state.quarterValue ? state.quarterValue : ''}
                  onBlur={(e) => handleOnblurEvent('quarter', e.target.value)}
                  onChange={(e) => {
                    handleOnChangeEvent(e.target.value, 'quarterValue');
                  }}
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'quarter' ? l.message : null
                        )
                      : null
                  }
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'quarter' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
              <div className="mui-custom-form d-flex justify-content-end btn-wrapper">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="search_button_rcdd"
                  onClick={() => {
                    onClickOnSearch();
                  }}
                >
                  <SVGComponent iconName="Icon-search" />
                  Search
                </Button>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-12">
            <TableGridWithFeatures
              data-testid="mfg-data-component-grid"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={requestScrMfgGridFullScrren}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={
                requestScrMfgGridFullScrren ? '70vh' : viewPortHeight_355
              }
              gridCall={onGridReady}
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              exportFile
              animateRows
              sideBar={false}
              fileName="mfg grid"
              columnDefs={mfgForRcddColoumData}
              rowData={mfgList}
              cellClickedListener={(e) => doubleClickOnSpecificRow(e.data)}
              onSelect={(e) => onSingleClickOnSPecificRow(e.data)}
            />
          </div>
        </div>
        <div className="row d-flex flex-row-reverse ">
          <div className=" m-4 btn-wrapper">
            <Button
              className="btn btn-success btn-save"
              data-testid="rcdd-process-button"
              disabled={mfgList.length > 0 ? false : true}
              onClick={() => {
                clickHandlerOnProcess();
              }}
            >
              <SVGComponent iconName="Create-new-icon" />
              &nbsp;Process
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default RequestCurrentDisputeDisplay;
